/**
 * Formatting utilities — presentation only.
 * NEVER put commercial rules or thresholds here.
 */

const DEFAULT_LOCALE = "es-MX";

/** @param {number} amount @param {string} [currency="USD"] */
export const fmtMoney = (amount, currency = "USD") =>
  new Intl.NumberFormat(DEFAULT_LOCALE, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount || 0);

/** @param {{amount:number, currency:string}} money */
export const fmtMoneyObj = (money) =>
  money ? fmtMoney(money.amount, money.currency) : "—";

/** @param {number} n */
export const fmtNumber = (n) =>
  new Intl.NumberFormat(DEFAULT_LOCALE).format(n || 0);

/** @param {number} p 0..1 */
export const fmtPct = (p) =>
  `${Math.round((p || 0) * 100)}%`;

/** @param {string} iso */
export const fmtDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(DEFAULT_LOCALE, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
};

/** @param {string} iso */
export const fmtRelative = (iso) => {
  if (!iso) return "—";
  const diffMs = new Date(iso).getTime() - Date.now();
  const abs = Math.abs(diffMs);
  const rtf = new Intl.RelativeTimeFormat(DEFAULT_LOCALE, { numeric: "auto" });
  const map = [
    ["year", 1000 * 60 * 60 * 24 * 365],
    ["month", 1000 * 60 * 60 * 24 * 30],
    ["day", 1000 * 60 * 60 * 24],
    ["hour", 1000 * 60 * 60],
    ["minute", 1000 * 60],
  ];
  for (const [unit, ms] of map) {
    if (abs >= ms) {
      return rtf.format(Math.round(diffMs / ms), unit);
    }
  }
  return "ahora";
};

/**
 * Human label for Estimate.label — kept in one place so we never leak
 * a raw enum into the UI.
 * @param {"commercial_value_estimated"|"potential_business"|"estimated_opportunity"|"projected_commission"} label
 */
export const estimateLabel = (label) => {
  const map = {
    commercial_value_estimated: "Valor comercial estimado",
    potential_business: "Negocio potencial",
    estimated_opportunity: "Oportunidad estimada",
    projected_commission: "Comisión proyectada",
  };
  return map[label] || "Estimación";
};
